import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/kmiWdzzkiwMBMz1kMjVhx3/ChatGPT_Image_25_may_2026,_17_51_23_(2).png', 'https://cdn.magicpatterns.com/uploads/8GyaS4ZSvgUwj61WFxssjy/ChatGPT_Image_25_may_2026,_17_51_23_(1).png', 'https://cdn.magicpatterns.com/uploads/64cj4Hxp2yECg8UiF4kZft/ChatGPT_Image_25_may_2026,_16_59_54_(1).png', 'https://cdn.magicpatterns.com/uploads/224m1Zaoex3xBeq5LySpBa/ChatGPT_Image_25_may_2026,_17_42_25_(1).png'];
export function ProductInside() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-sage/10 overflow-hidden" data-id="element-184">
      <div className="max-w-7xl mx-auto" data-id="element-185">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-186">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" data-id="element-187">
            Así se ve Flores de Chenille Deco por dentro
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-188">
            Un vistazo al contenido real del kit: páginas visuales, materiales,
            explicaciones paso a paso e ideas para que puedas crear con claridad
            desde el primer día.
          </p>
        </div>

        <div className="relative max-w-md sm:max-w-lg mx-auto" data-id="element-189">
          <div className="relative aspect-[3/4] w-full rounded-[2rem] overflow-hidden shadow-xl border-4 border-white bg-deco-card" data-id="element-190">
            <AnimatePresence mode="wait" data-id="element-191">
              <motion.img key={currentIndex} src={images[currentIndex]} alt={`Página interna ${currentIndex + 1}`} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.4
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-192" />
            </AnimatePresence>
          </div>

          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 sm:-translate-x-6 bg-white p-3 rounded-full shadow-lg border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10" aria-label="Anterior imagen" data-id="element-193">
            <ChevronLeft className="w-6 h-6" data-id="element-194" />
          </button>

          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 sm:translate-x-6 bg-white p-3 rounded-full shadow-lg border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10" aria-label="Siguiente imagen" data-id="element-195">
            <ChevronRight className="w-6 h-6" data-id="element-196" />
          </button>

          <div className="flex justify-center gap-3 mt-8" data-id="element-197">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-deco-terra w-8 sm:w-10' : 'bg-deco-warm hover:bg-deco-terra/50'}`} aria-label={`Ir a la imagen ${idx + 1}`} data-id="element-198" />)}
          </div>
        </div>
      </div>
    </section>;
}